import Migration from "@/utils/dataMigration/Migration";
import {migrateSessionServiceLinks} from "@/utils/dataMigration/database/SessionServiceMigration";

export default class Migration_25_26 extends Migration {
	constructor() {
		super(25, 26)
	}

	async migrate(dataManager, authManager) {
		await migrateSessionServiceLinks(dataManager, authManager)
	}
}
